export var TelemetryName;
(function (TelemetryName) {
    TelemetryName["LOG_IN"] = "LogIn";
    TelemetryName["GRANT_ACCESS"] = "GrantAccess_V2";
    TelemetryName["REVOKE_ACCESS"] = "RevokeAccess_V2";
    TelemetryName["CREATE_SNAPSHOT"] = "CreateSnapshot";
    TelemetryName["DELETE_SNAPSHOT"] = "DeleteSnapshot";
    TelemetryName["CREATE_SNAPSHOT_SCHEDULE"] = "CreateSnapshotSchedule";
    TelemetryName["DELETE_SNAPSHOT_SCHEDULE"] = "DeleteSnapshotSchedule";
    TelemetryName["SET_CONFIG"] = "SetConfig";
    TelemetryName["UNSET_CONFIG"] = "DeleteConfig";
})(TelemetryName || (TelemetryName = {}));
